module.exports = __webpack_public_path__ + "static/CircularStd-Black-59880bb792378f77deca117ea6b17567.woff";